export const GET_SHELVE_GOODS = "GET_SHELVE_GOODS";
export const GET_SHELVE_GOOD_BY_ID = "GET_SHELVE_GOOD_BY_ID";
export const UPDATE_SHELVE_GOOD = "UPDATE_SHELVE_GOOD";
export const DELETE_SHELVE_GOOD = "DELETE_SHELVE_GOOD";
export const CREATE_SHELVE_GOOD = "CREATE_SHELVE_GOOD";
